import MediaBanner from "./MediaBanner";
import MediaPost from "./MediaPost";
export default function MediaPage() {
  return (
    <>
      <MediaBanner />
      <MediaPost />
    </>
  );
}
